import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

const smsLoginInitApiLink = apiLink.user.smsLogin.init({});
const smsLoginVerifyApiLink = apiLink.user.smsLogin.verify({});

export interface ISmsLoginCredentials {
    email: string;
    phone: string;
}

export interface ISmsLoginPayload extends ISmsLoginCredentials {
    code: string;
}

export interface ISmsLoginResponse {
    email: string;
    phone: string;
    email_marketing_consent: boolean;
    phone_marketing_consent: boolean;
    can_receive_cpl_campaigns: boolean;
    user_created: false;
    uuid: string;
    name: string;
}

export interface ISmsLoginSendResult {
    error?: {
        message: string;
        status: number;
    };
}

const SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES = [400, 403, 422];

export const isSmsLoginAccountMismatchError = (error: {status: number}) => SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES.includes(error.status);

const getApiErrorDetail = (data: unknown) => {
    const errors = Array.isArray(data) ? data : [data];
    const errorWithDetail = errors.find(
        (error): error is {detail: string} => Boolean(error) && typeof error === "object" && "detail" in error && typeof error.detail === "string"
    );

    return errorWithDetail?.detail;
};

export const transformSmsLoginError = (
    response: Parameters<typeof getIgnoredNotifyResponse>[0],
    badRequestFallbackMessage: string,
    fallbackMessage: string,
    useApiErrorDetail = true
) => {
    const ignoredResponse = getIgnoredNotifyResponse(response, [...SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES, 429]);

    if (typeof response.status === "number" && SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES.includes(response.status)) {
        const errorMessage = useApiErrorDetail ? (getApiErrorDetail(response.data) ?? badRequestFallbackMessage) : badRequestFallbackMessage;

        return {...ignoredResponse, data: {error: errorMessage}, status: response.status};
    }

    if (response.status === 429) {
        return {...ignoredResponse, data: {error: "Przekroczono limit prób. Spróbuj ponownie za minutę."}, status: 429};
    }

    return {...ignoredResponse, data: {error: fallbackMessage}};
};

export const getSmsLoginError = (error: unknown, fallbackMessage: string) => {
    if (isFetchBaseQueryError(error)) {
        const status = typeof error.status === "number" ? error.status : 500;

        if (error.data && typeof error.data === "object") {
            if ("error" in error.data && typeof error.data.error === "string") {
                return {message: error.data.error, status};
            }

            if ("detail" in error.data && typeof error.data.detail === "string") {
                return {message: error.data.detail, status};
            }
        }

        return {message: fallbackMessage, status};
    }

    return {message: fallbackMessage, status: 500};
};

export const smsLoginApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postSmsLoginInit: build.mutation<void, ISmsLoginCredentials>({
            query: (body) => ({
                url: smsLoginInitApiLink(null),
                method: "POST",
                body
            }),
            transformErrorResponse: (response) =>
                transformSmsLoginError(response, "Podany numer telefonu nie jest przypisany do tego adresu e-mail", "Nie udało się wysłać kodu SMS")
        }),
        postSmsLogin: build.mutation<ISmsLoginResponse, ISmsLoginPayload>({
            query: (body) => ({
                url: smsLoginVerifyApiLink(null),
                method: "POST",
                body
            }),
            transformErrorResponse: (response) =>
                transformSmsLoginError(response, "Kod jest nieprawidłowy, spróbuj ponownie", "Nie udało się zweryfikować kodu SMS", false)
        })
    }),
    overrideExisting: false
});

export const {usePostSmsLoginInitMutation, usePostSmsLoginMutation} = smsLoginApi;
import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

const smsLoginInitApiLink = apiLink.user.smsLogin.init({});
const smsLoginVerifyApiLink = apiLink.user.smsLogin.verify({});

export interface ISmsLoginCredentials {
    email: string;
    phone: string;
}

export interface ISmsLoginPayload extends ISmsLoginCredentials {
    code: string;
}

export interface ISmsLoginResponse {
    email: string;
    phone: string;
    email_marketing_consent: boolean;
    phone_marketing_consent: boolean;
    can_receive_cpl_campaigns: boolean;
    user_created: false;
    uuid: string;
    name: string;
}

export interface ISmsLoginSendResult {
    error?: {
        message: string;
        status: number;
    };
}

const SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES = [400, 403, 422];

export const isSmsLoginAccountMismatchError = (error: {status: number}) => SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES.includes(error.status);

const getApiErrorDetail = (data: unknown) => {
    const errors = Array.isArray(data) ? data : [data];
    const errorWithDetail = errors.find(
        (error): error is {detail: string} => Boolean(error) && typeof error === "object" && "detail" in error && typeof error.detail === "string"
    );

    return errorWithDetail?.detail;
};

export const transformSmsLoginError = (
    response: Parameters<typeof getIgnoredNotifyResponse>[0],
    badRequestFallbackMessage: string,
    fallbackMessage: string,
    useApiErrorDetail = true
) => {
    const ignoredResponse = getIgnoredNotifyResponse(response, [...SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES, 429]);

    if (typeof response.status === "number" && SMS_LOGIN_ACCOUNT_MISMATCH_STATUSES.includes(response.status)) {
        const errorMessage = useApiErrorDetail ? (getApiErrorDetail(response.data) ?? badRequestFallbackMessage) : badRequestFallbackMessage;

        return {...ignoredResponse, data: {error: errorMessage}, status: response.status};
    }

    if (response.status === 429) {
        return {...ignoredResponse, data: {error: "Przekroczono limit prób. Spróbuj ponownie za minutę."}, status: 429};
    }

    return {...ignoredResponse, data: {error: fallbackMessage}};
};

export const getSmsLoginError = (error: unknown, fallbackMessage: string) => {
    if (isFetchBaseQueryError(error)) {
        const status = typeof error.status === "number" ? error.status : 500;

        if (error.data && typeof error.data === "object") {
            if ("error" in error.data && typeof error.data.error === "string") {
                return {message: error.data.error, status};
            }

            if ("detail" in error.data && typeof error.data.detail === "string") {
                return {message: error.data.detail, status};
            }
        }

        return {message: fallbackMessage, status};
    }

    return {message: fallbackMessage, status: 500};
};

export const smsLoginApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postSmsLoginInit: build.mutation<void, ISmsLoginCredentials>({
            query: (body) => ({
                url: smsLoginInitApiLink(null),
                method: "POST",
                body
            }),
            transformErrorResponse: (response) =>
                transformSmsLoginError(response, "Podany numer telefonu nie jest przypisany do tego adresu e-mail", "Nie udało się wysłać kodu SMS")
        }),
        postSmsLogin: build.mutation<ISmsLoginResponse, ISmsLoginPayload>({
            query: (body) => ({
                url: smsLoginVerifyApiLink(null),
                method: "POST",
                body
            }),
            transformErrorResponse: (response) =>
                transformSmsLoginError(response, "Kod jest nieprawidłowy, spróbuj ponownie", "Nie udało się zweryfikować kodu SMS", false)
        })
    }),
    overrideExisting: false
});

export const {usePostSmsLoginInitMutation, usePostSmsLoginMutation} = smsLoginApi;
